<template>
  <div class='container-fluid'>
    <b-row>
      <NewTag />
    </b-row>
    <b-row>
      <div>
        <b-table fixed :items="tags" :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc">
          <template slot="name" slot-scope="row">
            <span class="tag" :style="{ background: row.item.color }">
              {{row.item.name}}
            </span>
          </template>
          <template slot="edit" slot-scope="row">
             <b-button size="sm" @click="editTag(row.item)" class="mr-2">
               Edit
             </b-button>
          </template>
        </b-table>
      </div>
    </b-row>
  </div>
</template>

<script>
import NewTag from './NewTag'
export default {
  name: 'AdminTags',
  data () {
    return {
      tags: [],
      fields: [
        {
          key: 'name',
          sortable: true
        },
        {
          key: 'taggings_count',
          sortable: true
        },
        {
          key: 'edit'
        }
      ],
      sortBy: 'taggings_count',
      sortDesc: true
    }
  },
  components: {
    NewTag
  },
  created () {
    this.getTags()
  },
  mounted () {
    this.$root.$on('tagWasAdded', () => { this.getTags() })
  },
  methods: {
    getTags () {
      var vm = this
      this.$http.get('/tags')
        .then(function (response) {
          vm.tags = response.data.tags
        })
        .catch(e => { console.log(e.response) })
    },
    editTag (item) {
      this.$root.$emit('editTag', item)
    }
  }
}
</script>

<style scoped>
  .tag {
    border-radius: 2px;
    display: inline-block;
    font-size: 11px;
    font-weight: 600;
    padding: 3px 4px;
    cursor: pointer;
    line-height: 12px;
    margin: 6px 2px 0px 1px;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/Tags.vue